import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import InventoryPage from '../pages/InventoryPage';
import ChannelsPage from '../pages/ChannelsPage';
import AccountManagementPage from '../pages/AccountManagementPage';
import SalesTransactions from '../components/SalesTransactions';
import Expenses from '../components/Expenses';
import MileageLog from '../components/MileageLog';
import HelpAndSupport from '../components/HelpAndSupport';
import SubscriptionLayout from '../layouts/SubscriptionLayout';
import SubscriptionRequiredPage from '../pages/SubscriptionRequiredPage';
import PageTransition from '../components/PageTransition';

const ReportsPage = React.lazy(() => import('../pages/ReportsPage'));
const ImportDataPage = React.lazy(() => import('../pages/ImportDataPage'));
const ExportData = React.lazy(() => import('../components/ExportData'));

const AppRoutes = ({
  inventoryProps,
  channelsProps,
  reportsProps,
  accountProps,
  salesTransactionsProps,
  expensesProps,
  mileageProps,
  importDataProps,
  exportDataProps,
  helpProps,
  subscriptionProps,
}) => {
  return (
    <Suspense fallback={<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}><CircularProgress /></Box>}>
    <Routes>
      <Route
        path="/"
        element={<PageTransition><InventoryPage {...inventoryProps} /></PageTransition>}
      />
      <Route
        path="/channels"
        element={<PageTransition><ChannelsPage {...channelsProps} /></PageTransition>}
      />
      <Route
        path="/reports"
        element={<PageTransition><ReportsPage {...reportsProps} /></PageTransition>}
      />
      <Route path="/import-data" element={<PageTransition><ImportDataPage {...importDataProps} /></PageTransition>} />
      <Route path="/export-data" element={<PageTransition><ExportData {...exportDataProps} /></PageTransition>} />
      <Route
        path="/account"
        element={<PageTransition><AccountManagementPage {...accountProps} /></PageTransition>}
      />
      <Route
        path="/sales-transactions"
        element={<PageTransition><SalesTransactions {...salesTransactionsProps} /></PageTransition>}
      />
      <Route
        path="/expenses"
        element={<PageTransition><Expenses {...expensesProps} /></PageTransition>}
      />
      <Route
        path="/mileage"
        element={<PageTransition><MileageLog {...mileageProps} /></PageTransition>}
      />
      <Route path="/help" element={<PageTransition><HelpAndSupport {...helpProps} /></PageTransition>} />
      <Route
        path="/subscription-required"
        element={
          <SubscriptionLayout>
            <PageTransition><SubscriptionRequiredPage {...subscriptionProps} /></PageTransition>
          </SubscriptionLayout>
        }
      />
      <Route path="/setup/*" element={<Navigate to="/" replace />} />
      <Route path="/app" element={<Navigate to="/" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </Suspense>
  );
};

export default AppRoutes;
